import React from 'react';
import { Input } from 'antd';
import passwordIcon from '@/assets/icons/passwordIcon.webp';
import styles from '../LoginModal.module.scss';

const ResetPasswordForm = ({
  newPassword,
  onNewPasswordChange,
  confirmPassword,
  onConfirmPasswordChange,
  passwordError,
  onReset,
  loadingStates,
  validatePassword,
}) => {
  return (
    <div className={styles.resetPasswordForm}>
      <div className={styles.passwordInputContainer}>
        <div className={styles.passwordIcon}>
          <img src={passwordIcon} alt="" />
        </div>
        <Input.Password
          placeholder="请输入密码"
          className={styles.loginInput}
          value={newPassword}
          onChange={(e) => {
            const value = e.target.value;
            onNewPasswordChange(value);
            validatePassword(value, confirmPassword);
          }}
        />
      </div>
      <div className={styles.passwordInputContainer}>
        <div className={styles.passwordIcon}>
          <img src={passwordIcon} alt="" />
        </div>
        <Input.Password
          placeholder="请再次输入密码"
          className={styles.loginInput}
          value={confirmPassword}
          onChange={(e) => {
            const value = e.target.value;
            onConfirmPasswordChange(value);
            validatePassword(newPassword, value);
          }}
        />
      </div>
      {passwordError && (
        <div className={styles.errorMessage}>{passwordError}</div>
      )}
      <button className={styles.loginBtn} onClick={onReset}>
        {loadingStates.resetPassword ? (
          <div className={styles.buttonLoading}>
            <div className={styles.spinner} />
          </div>
        ) : (
          '确认'
        )}
      </button>
    </div>
  );
};

export default ResetPasswordForm;
